import { Share2Icon, UsersIcon } from 'lucide-react';
import { FC } from 'react';
import type { SharedPresetUser } from '@/entities/shared-presets';
import { getFullName } from '@/shared/lib';
import { LabeledIcon } from '@/shared/ui';

type Props = {
  preset: {
    isSystem: boolean;
    isShared: boolean;
    isEditable: boolean;
    /** Владелец совместного пресета — его имя называет значок у получателя */
    owner?: SharedPresetUser;
  };
  /** Подписи значков в словаре списка: пресет таблицы и дашборд называются по-своему */
  labels: {
    system: string;
    shared: string;
    /** Подпись совместного пресета у получателя — с именем владельца */
    sharedBy: (ownerName: string) => string;
  };
};

/**
 * Значки вида пресета в его строке — системный или совместный. У получателя совместного пресета
 * подпись называет владельца: править пресет может только он.
 */
export const PresetKindIcons: FC<Props> = ({ preset, labels }) => {
  const sharedLabel =
    preset.owner && !preset.isEditable
      ? labels.sharedBy(getFullName(preset.owner.firstName, preset.owner.lastName))
      : labels.shared;

  return (
    <>
      {preset.isSystem && <LabeledIcon label={labels.system} icon={<UsersIcon className="size-3.5" />} />}
      {preset.isShared && <LabeledIcon label={sharedLabel} icon={<Share2Icon className="size-3.5" />} />}
    </>
  );
};
